import { executeRequest, JFSRequest } from '@jfs/network'
import { getAcceptableStatus, isSuccessResponse } from '../utils/index'
import { dateFormatter, DateFormatTypes, fromDateTime, toDateTime } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const parser = (dataList: any, count: number) => {
  let parsedList: any[] = []
  dataList?.map((data) => {
    parsedList.push({
      legalName: data?.inputDto?.legalName,
      creationDate: dateFormatter(data?.createdAt, DateFormatTypes.TIME_STAMP),
      mobileNumber:
        data?.inputDto?.groupContacts?.[0]?.mobileNumber ?? data?.inputDto?.contactDetails?.[0]?.mobileNumber ?? 'NA',
      requestType: data?.inputDto?.type,
      type: data?.applicationType,
      status: data?.status,
      isSelected: data?.isSelected ?? false,
      assignee: data?.claimedByUser?.userId,
      applicationId: data?.processInstanceId,
      groupAddress: data?.inputDto?.groupAddress ? data?.inputDto?.groupAddress : data?.inputDto?.addressDetails,
      groupContacts: data?.inputDto?.groupContacts
        ? data?.inputDto?.groupContacts
        : data?.inputDto?.contactDetails
        ? data?.inputDto?.contactDetails
        : [],
      businessName:
        data?.applicationType === 'GROUP_ADD' || data?.applicationType === 'SUBGROUP_ADD'
          ? data?.inputDto?.brandName
          : data?.inputDto?.businessName,
      addressDetails: data?.inputDto?.addressDetails,
      contactDetails: data?.inputDto?.contactDetails,
      identificationNumber: data?.identificationNumber,
      gstDetails: data?.inputDto?.gstDetails,
      settlementDetails: data?.inputDto?.settlementDetails,
      feePackageDetails: data?.inputDto?.feePackageDetails,
      programCategoryDetails: data?.inputDto?.programCategoryDetails,
      deviceDetails: data?.inputDto?.deviceDetails,
      businessProfile: data?.inputDto?.businessProfile,
      source: data?.source,
      parentEntityIdentificationNumber: data?.inputDto?.parentEntityIdentificationNumber,
      subGroupIdentificationNumber: data?.inputDto?.subGroupIdentificationNumber,
      applicationStatus: data?.applicationState === 'Pending' ? 'Pending For Approval' : data?.applicationState,
      errorReason: data?.errorReason,
      errorTask: data?.errorTask,
      inProgressTask: data?.inProgressTask,
      completedTaskList: data?.completedTaskList,
      applicationType: data?.applicationType,
      comments: data?.comments,
      terminalDetails: data?.terminalDetails,
      jfsUserid: data?.jfsUserid,
      uploadId: data?.inputDto?.uploadId,
    })
  })
  console.log('parsedList::', parsedList)
  return { list: parsedList, count: count }
}
const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return parser(data?.processInstances, data?.totalItems)
}

const getMyCheckerListReq = (
  assignee: string,
  pagination: any,
  selectedDateInfo: any,
  applicationStatus: any,
  tokens: any,
  searchBy?: string,
  searchKey?: string,
) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getMyCheckerList),
    method: 'POST',
    cache: false,
    body: {
      configParams: {
        page: searchBy && searchBy?.length > 0 && searchKey?.length > 0 ? 1 : pagination.number,
        recordCount: 10,
      },
      inputFilters: {
        endDateTime:
          selectedDateInfo.toDate !== new Date(Date.now())
            ? toDateTime(new Date(Date.now()))
            : toDateTime(selectedDateInfo.toDate),
        startDateTime: fromDateTime(selectedDateInfo.fromDate),
        assignee: assignee,
        ...(applicationStatus.length > 0 &&
          !applicationStatus?.includes('ALL') && {
            status: getAcceptableStatus(applicationStatus),
          }),
        ...(searchBy?.length > 0 && searchKey?.length > 0 && { [searchBy]: searchKey }),
      },
    },
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getMyCheckerListReq }
